import dadosAgenciaComum from './dadosAgenciaComum';

export const dadosCrispinPassagens = {
    ...dadosAgenciaComum,
    id: 'crispinpassagens',
    nome: 'Crispin Passagens',
    instagram: 'instagram.com',
    facebook: 'facebook.com',
    youtube: 'youtube.com',
    email: 'suportevexado@gmail.com',
    idsTagManager: ['GTM-PHNM3T7']
};
